// Using double quotes in this file to prevent issues with apostrophes (')
export default {
  header: {
    ai: {
      title: '询问 HP Nio',
      close: '关闭 Nio 聊天',
      open: '打开 Nio 聊天',
      morningGreeting: "早上好 {0}，",
      afternoonGreeting: "下午好 {0}，",
      eveningGreeting: "晚上好 {0}，",
      morningGreetingGeneric: "早上好，",
      afternoonGreetingGeneric: "下午好，",
      eveningGreetingGeneric: "晚上好，",
      opening: "我是 Nio，我能帮您什么忙?",
      openingPrivacy: "我是 Nio。",
      pbIntro1: "询问我有关您设备生产率的问题。",
      alertDefault: "Nio 正处于早期测试阶段。目前，其回答范围仅涵盖 PrintBeat 和 Knowledge Zone。",
      intro2:  "以下是您可能感兴趣的一些问题:",
      kzIntro1: "就您关心的问题向我提问，我将通过知识库的信息做出回答。",
      pbSample1: "昨天站点的生产情况如何?",
      pbSample2: "我如何提高生产效率?",
      pbSample3: "在我所有的印刷机中，哪台印刷机表现出色?",
      pbSample4: "哪种承印物让我损失的时间最多?",
      pbSample5: "上周我在哪个问题上浪费的时间最多?",
      kzSample1: "我如何在保持质量和削减成本的同时减少承印物浪费?",
      kzSample2: "哪台 HP Indigo press 最适合执行高效、颜色一致的酒类标签印刷?",
      kzSample3: "我如何优化耗材使用情况来提高生产效率?",
      kzSample4: "在印刷时我应考虑哪些关键的可持续性因素?",
      kzSample5: "我如何确保 HP Indigo 6000 press 和 HP Indigo 20K press 之间的颜色一致性?",
      feedbackTitle: "您的评分理由",
      feedbackPlaceholder: "您能否详细解释一下发生了什么？?",
      fbPositive1: "数据正确",
      fbPositive2: "回复非常好",
      fbPositive3: "非常详细",
      fbPositive4: "回复内容密切相关",
      fbOther: "其他",
      fbNegative1: "信息或数据不正确",
      fbNegative2: "该回复未回答我的问题",
      fbNegative3: "该回复令人困惑或表述不清",
      fbNegative4: "回复内容不相关",
      feedbackSubmittedTitle: "感谢您的反馈!",
      feedbackSubmittedDescription_Positive: "很高兴听到我们的回复对您有所帮助！您的反馈激励我们持续为您提供更优质的体验。",
      feedbackSubmittedDescription_Negative: "对于由此可能给您带来的不便，我们深表歉意。我们的团队将审核相关信息并着手纠正。如有关于该错误的更多细节或额外反馈，请告知我们，以便我们改进。",
      ask_Placeholder: "您想知道些什么?",
      answerCopiedToClipboard: "答案已复制到剪贴板",
      feedbackSubmitted: "反馈已提交",
      feedbackCleared: "反馈已删除",
      newConversation: "新聊天",
      chatHistory: "聊天历史记录",
      submitQuestion: "提交问题",
      responseError: "抱歉，我们的系统似乎出现问题。请稍后重试。如果问题仍然存在，请联系支持部门。",
      responseError400: "您的问题似乎包含非常规字符。请删除这些内容后再继续。",
      responseError429: "抱歉，问题过多，我无法处理，请放缓提问节奏。",
      like: "赞",
      dislike: "踩",
      copy: "复制到剪贴板",
      retry: "重试",
      contact: "联系我们",
      contactSubject: "HP Nio 问题",
      contactQuestion: "问题: {0}",
      noConversations: "您没有对话",
      startConversation: "可在此处开启对话以查看您的聊天历史记录",
      today: "今天",
      yesterday: "昨天",
      privacyNotice: "您当前使用的是 AI 解决方案。请对生成的答案进行审核，因其可能存在内容不完整或信息不准确的情况。",
      privacy1: "您即将使用 AI 解决方案。对话内容可能会被审核并用于训练我们的模型。",
      privacy2: `If you prefer to receive support in another way, please visit {0}.`,
      acceptPrivacy: "开始与 HP Nio 聊天",
      deleteConversationTitle: "删除对话",
      conversationName: "对话",
      deleteConversationConfirm: "这将删除 <b>{0}</b>。",
      deleteConversationSuccess: "对话已删除",
      deleteConversationError: "无法删除对话",
      renameConversationTitle: "重命名对话",
      renameConversationMessage: "对话名称",
      renameConversationSuccess: "对话已重命名",
      renameConversationError: "无法重命名对话",
      deleteConversation: "删除",
      renameConversation: "重命名",
    },
    apps: {
      title: "菜单",
      externalLinks: "外部",
      availableApps: "探索",
      configure: "自定义",
      showApp: "显示",
      hideApp: "隐藏",
      setDefault: "设置默认应用程序",
      setShortcut: "设置为已固定",
      removeShortcut: "取消固定",
      showAllApps: "显示所有应用程序",
      shortCutTooltip: "转到 {0}",
      currentAccount: "当前组织",
      goHome: "转至主页",
      goAppHome: "转到应用程序开始页面",
      byProvider: "提供商: {0}",
      quickFilter: "查找应用程序...",
      allApps: "所有应用",
      recentApps: "近期",
      externalApp: "PrintOS 外部的应用程序",
      modeSwitcher: "深色/浅色模式",
      goProducts: "探索更多应用程序"
    },
    panels: {
      ai: "询问 HP Nio",
      notifications: "我的通知",
      help: "帮助与支持",
      user: "用户",
      close: "关闭面板",
      moveLeft: "左移",
      moveRight: "右移",
      maximize: "最大化",
      restore: "还原",
    },
    user: {
      account: "组织",
      returnToHP: "返回至 HP Inc.",
      myOrganization: "我的组织",
      myOrganizations: "我的组织",
      myReports: "我的报告",
      mySettings: "我的设置",
      signOut: "注销",
      signInExplanation: "登录到 HP PrintOS 以查看您的通知和应用程序。",
      signIn: "登录",
      RCDA: "客户访问",
      orphanUser: "PrintOS 用户",
      orphanContext: "无组织",
      deviceUser: "PrintOS 设备",
      anonymous: "匿名用户",
      name: "名称",
      email: "电子邮件",
      address: "地址",
      editUser: "编辑 HP 帐户",
      viewPrivacy: "查看隐私声明"
    },
    date: {
      fewSecondsAgo: "几秒钟前",
      minuteAgo: "一分钟前",
      minutesAgo: "{0} 分钟前",
      hourAgo: "一小时前",
      hoursAgo: "{0} 小时前",
      dayAgo: "一天前",
      daysAgo: "{0} 天前",
      monthAgo: "一个月前",
      monthsAgo: "{0} 个月前",
      yearAgo: "一年前",
      yearsAgo: "{0} 年前",
    },
    help: {
      quickFilter: "搜索",
      page: "页面",
      app: "应用",
      newFeatures: "新功能",
      more: "全部",
      contactHP: "联系 HP",
      noTopics: "没有匹配的帮助主题",
      about: "关于",
      terms: "服务条款",
      readFile: "文档",
      stepByStepTutorial: "教程",
      goLink: "应用程序页面",
      viewVideo: "视频",
      goToUrl: "链接",
      other: "其他",
      faq: "常见问题",
      new: "新建主题",
      whatsNew: "新增功能",
      technicalSupport: "PrintOS 支持",
      printOSFeedback: "PrintOS 反馈",
      conversationsWithHP: "与 HP 对话",
      youMayConsider: "您可能想要...",
      myKzArticles: "我的知识库文章",
      kzServiceTopics: "{0} ({1})",
      lkcArticles: "HP Latex 知识中心文章",
    },
    notifications: {
      noNotifications: "没有任何通知",
      viewAll: "查看全部",
      dismiss: "取消",
      dismissAll: "一次取消",
      subscriptions: "设置",
    },
    marketplace: {
      title: "市场",
      explore: "全部浏览",
      featured: "特色",
      slides: {
        default: {
          description: "利用优质应用程序、扩展程序和连接器增强 PrintOS"
        },
        oee: {
          title: "Print Beat OEE",
          description: "使用近乎实时的数据驱动洞察力来实现运营卓越性",
        },
      },
      partialProductivitySubscribePreEnforcement_Title: "自 8 月 4 日起，访问 Indigo Print Beat、作业、OEE 和 Print Beat 服务将需要<a href='https:/intercom.help/hp-printos/en/articles/11113950-hp-printos-productivity-power-pack' target='_blank'>订阅 Productivity Power Pack</a>。",
      partialProductivitySubscribePreEnforcement_Desc: "来自未订阅设备的数据可在 8 月之前取出。",
      partialProductivitySubscribePostEnforcement_Title: "不是所有的 Indigo 设备均订阅了 Productivity Power Pack ({0}/{1})",
      partialProductivitySubscribePostEnforcement_Desc: "取消订阅的设备可能无法充分享受 PrintOS 体验(Print Beat、Jobs、OEE、显示板、...)",
      goToMarket_Action: "前往市场",
      howToExtract_Action: "如何提取我的数据"
    },
    focus: {
      title: "Focus",
    },
    locales: {
      "de-DE": "德语",
      "en-GB": "英语(英国)",
      "en-US": "英语(美国)",
      "es-ES": "西班牙语",
      "fr-FR": "法语",
      "it-IT": "意大利语",
      "ja-JP": "日语",
      "ko-KO": "韩语",
      "pt-PT": "葡萄牙语",
      "tr-TR": "土耳其语",
      "zh-HANS": "中文(简体)",
      "ru-RU": "俄语",
      "部分翻译": "部分翻译",
    },
    modal: {
      ok: "确定",
      cancel: "取消",
    },
    combo: {
      noItems: "无匹配",
    },
    nps: {
      question: "{0}，您好。您向同事推荐 PrintOS 的可能性有多大?",
      // In case we can't get user's display name
      questionNameless: "您向同事推荐 PrintOS 的可能性有多大?",
      notLikely: "根本不可能",
      likely: "极有可能",
      send: "发送反馈",
      response: {
        detractor: "{0}，我们可以从哪一方面改善您的 PrintOS 体验? 我们会认真查看每条评论。",
        detractorNameless: "我们可以从哪一方面改善您的 PrintOS 体验? 我们会认真查看每条评论。",
        passive: "{0}，告诉我们如何进一步改善您的 PrintOS 体验。我们会认真查看每条评论。",
        passiveNameless: "告诉我们如何进一步改善您的 PrintOS 体验。我们会认真查看每条评论。",
        promoter: "{0}，我们很高兴得知您喜欢使用 PrintOS! 不妨分享下您喜爱它的原因。我们会认真查看每条评论。",
        promoterNameless: "我们很高兴得知您喜欢使用 PrintOS! 不妨分享下您喜爱它的原因。我们会认真查看每条评论。",
      },
      introMorning: "早上好 {0}，我是 PrintOS 的客户成功经理 Jon。",
      introMorningNameless: "早上好，我是 PrintOS 的客户成功经理 Jon。",
      introAfternoon: "下午好 {0}，我是 PrintOS 的客户成功经理 Jon。",
      introAfternoonNameless: "下午好，我是 PrintOS 的客户成功经理 Jon。",
      introEvening: "晚上好 {0}，我是 PrintOS 的客户成功经理 Jon。",
      introEveningNameless: "晚上好，我是 PrintOS 的客户成功经理 Jon。",
      intro2: "请回答以下问题以帮助我了解您的 PrintOS 使用体验:",
      intro3: "您向同事推荐 PrintOS 的可能性有多大?",
      detractorResponse: "谢谢您的回复，{0}! 不管是正面反馈还是负面反馈，我们都非常重视。",
      detractorResponseNameless: "谢谢您的回复! 不管是正面反馈还是负面反馈，我们都非常重视。",
      promoterResponse: "谢谢，{0}! 很高兴得知您对 PrintOS 的喜爱。您的反馈还可以帮助我们为客户提供最佳使用体验。",
      promoterResponseNameless: "谢谢! 很高兴得知您对 PrintOS 的喜爱。您的反馈还可以帮助我们为客户提供最佳使用体验。",
      response2: "请选择应用程序并告知我们您认为 PrintOS 还有哪些改进之处。",
      response3: "客户成功团队会认真查看所有意见。我们可能会与您联系，以便更好地了解您的反馈。",
      feedbackPlaceholder: "您可以通过以下方式改进 PrintOS...",
      application: "应用",
      noApplication: "PrintOS - 一般反馈"
    },
    subscription: {
      title: "订阅",
      subscribe: "立即订阅!",
      noticeSingular: "您的 {0} 订阅将于 {1} 天后过期。",
      notice: "您的 {0} 订阅将于 {1} 天后过期。",
    },
    promotion: {
      label: "促销",
      title: "促销期通知",
      notice: "您使用的此应用程序正处于促销期。",
    },
    trial: {
      label: "试用即将过期",
      title: "试用期",
      noticeSingular: "{0} 处于试用期内。您的试用将在 {1} 天后过期。",
      notice: "{0} 处于试用期内。您的试用将在 {1} 天后过期。",
    },
    subscriptionExpired: {
      label: "订阅已过期",
      title: "订阅已过期",
      notice: "您的 {0} 订阅已过期。在短暂的宽限期后，您将无法再访问此功能。",
    },
    trialExpired: {
      label: "试用已过期",
      title: "试用期已过期",
      notice: "您的 {0} 试用期已过期。在短暂的宽限期后，您将无法再访问此功能。",
    },
    hpWarning: "{0}\n您是客户组织的 HP Inc. 代表。请谨慎操作。",
    role: {
      HP_Operation: "HP 操作",
      HP_Sales_and_Marketing: "面向 HP 客户",
      SystemRoleGenesis_Admin: "PrintOS 服务管理员",
      SystemRoleGenesis_Support: "HP Inc. 管理员",
      SystemRoleGenesis_R_AND_D: "Genesis 研发",
      CE_Level_1: "CE 级别 1",
      CE_Level_2: "CE 级别 2",
      Application_Engineer: "应用工程师",
      Ramp_Up_Engineer: "启动计划工程师",
      Support_Engineer: "支持工程师",
      Remote_Support_Engineer: "HP 支持工程师",
      Specialist: "专家",
      Certification_Centers: "认证中心",
      Supplies_and_Media_Personnel: "耗材和介质人员",
      Supplies_and_Media_Admin: "耗材和介质管理员",
      HP_Service: "HP 服务",
      HP_Training: "HP 培训",
      Admin: "管理员",
      Pre_Press_Operator: "用户",
      Press_Operator: "操作员",
      Dashboard: "显示板",
      Channel_Sales_and_Marketing: "渠道销售和营销",
      Channel_Operation: "渠道操作",
      Channel_CE_Level_1: "渠道 CE 级别 1",
      Channel_CE_Level_2: "渠道 CE 级别 2",
      HP_Read_Only: "HP 只读",
      Reseller_Manager: "经销商经理",
      Business_Partner_Manager: "业务合作伙伴管理器",
      Call_Center: "呼叫中心",
      Field_Engineer: "现场工程师",
      ThreeD_Business_Manager: "3D 业务管理器",
      HPInPsp: "PSP 中的 HP",
      ChannelInPsp: "PSP 中的通道",
      GenericAdmin: "管理员",
      GenericUser1: "用户级别 1",
      GenericUser2: "用户级别 2",
      Generic_Read_Only: "只读",
      ThreeD_Care_Center: "3D Care Center",
      ThreeD_Cost_Calculator: "3D 涂布",
      Composer_External: "受限访问 - Composer",
      SIM_External: "受限访问 - 耗材库存管理器",
      Multiple: "多个角色"
    },
    inlineAlerts: {
      Http_429_Error: "高流量",
      Http_429_Description: "该服务目前遇到异常负载。某些功能可能暂时不可用。刷新页面以重试",
      Http_429_Action: "刷新",
      NewSubscription: "新订阅 - {0}",
      NewSubscriptionDescription: "您的组织具有新订阅",
      NewSubscriptionAction: "了解更多信息",
      SubscriptionExpired: "订阅已到期 - {0}",
      SubscriptionExpiredDescription: "您的订阅已于 {0} 到期",
      SubscriptionExpiredAction: "查看订阅",
      Subscription30DayWarning: "订阅将到期 - {0}",
      Subscription30DayWarningDescription: "您的订阅将在 {0} 天后于 {1} 到期",
      Subscription30DayWarningAction: "查看订阅",
      Subscription15DayWarning: "订阅即将到期 - {0}",
      Subscription15DayWarningDescription: "您的订阅将在 {0} 天后于 {1} 到期",
      Subscription15DayWarningAction: "查看订阅",
      JoinOrgRequestAccepted: "已接受加入组织请求",
      JoinOrgRequestAcceptedDescription: "您已有权访问 <b>{0}</b>",
      JoinOrgRequestSwitch: "打开组织",
      JoinOrgRequestDenied: "已拒绝加入组织请求",
      JoinOrgRequestDeniedDescription: "管理员已拒绝您加入 <b>{0}</b> 的请求",
      NonHPContext: "打开非 HP 上下文窗口",
      NonHPContextDescription: "上下文: {0}",
      CloseContext: "关闭上下文"
    },
    ui: {
      Confirm: "确认",
      Notify: "通知",
      OpenImage: "打开图像文件",
      Dismiss: "取消",
      CheckingContext: "正在检查上下文...",
      LoadingContext: "正在还原 {0}..."
    }
  }
};
